(function () {
  'use strict';


  function initInteractiveDots(banner) {
    if (!banner) return;
    var triggers = banner.querySelectorAll('.banner__dot-trigger');
    var contentSlot = banner.querySelector('.banner__callout-content-slot');
    var contentBottom = banner.querySelector('.banner__callout-content-bottom');
    var loadingCircle = contentBottom ? contentBottom.querySelector('.banner__loading-circle') : null;
    if (!triggers.length || !contentSlot || !contentBottom) return;

    var currentIndex = 0;
    var loadingTimeout = null;
    var loadingAnimationListener = null;

    function copyContentToSlot(callout) {
      var content = callout ? callout.querySelector('.banner__callout-content') : null;
      contentSlot.innerHTML = '';
      if (content) {
        var copy = content.cloneNode(true);
        copy.classList.add('banner__callout-content--slot');
        contentSlot.appendChild(copy);
      }
    }

    function showCopy(trigger) {
      var callout = trigger.closest('.banner__callout--interactive-dot');
      copyContentToSlot(callout);

      triggers.forEach(function (t) {
        t.classList.toggle('is-active', t === trigger);
      });

      currentIndex = Array.prototype.indexOf.call(triggers, trigger);

      /* Start loading animation - when complete (circle is all brand-accent-2), advance to next copy */
      if (loadingCircle) {
        loadingCircle.classList.remove('is-loading');
        loadingCircle.offsetHeight; /* force reflow to restart animation */
        loadingCircle.classList.add('is-loading');

        if (loadingAnimationListener) {
          loadingCircle.removeEventListener('animationend', loadingAnimationListener);
        }
        loadingAnimationListener = function () {
          var nextIndex = (currentIndex + 1) % triggers.length;
          showCopy(triggers[nextIndex]);
        };
        loadingCircle.addEventListener('animationend', loadingAnimationListener);
      }
    }

    function handleDotClick(e) {
      var trigger = e.target.closest('.banner__dot-trigger');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      showCopy(trigger);
    }

    banner.addEventListener('click', handleDotClick);

    showCopy(triggers[0]);
  }

  function init() {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (section) {
      var banner = section.querySelector('.banner');
      var contentSlot = section.querySelector('.banner__callout-content-slot');
      var triggers = section.querySelectorAll('.banner__dot-trigger');
      if (banner && contentSlot && triggers.length) {
        initInteractiveDots(banner);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);

  document.addEventListener('shopify:section:load', function (e) {
    var banner = e.target.querySelector('.banner');
    var contentSlot = e.target.querySelector('.banner__callout-content-slot');
    var triggers = e.target.querySelectorAll('.banner__dot-trigger');
    if (banner && contentSlot && triggers.length) {
      initInteractiveDots(banner);
    }
  });
})();
